import { api } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { 
    HazardousResponse,
    HazardousParams,
} from "@/interface/management/mg_hazardous/index";

export const useHazardous = (params: HazardousParams) => {
    const { searchType, search, dateFrom, dateTo, exactMatch, page, size } = params;
    return useQuery<HazardousResponse>({
        queryKey: ["hazardous", searchType, search, dateFrom, dateTo, exactMatch, page, size],
        queryFn: async () => {
            const response = await api.get("/hazardous", {
                params: { searchType, search, dateFrom, dateTo, exactMatch, page, size }
            });
            return response.data;
        },
        gcTime: 0,
        refetchOnMount: true,
    });
};
